<div class="login-page">
    <div class="login-card">
    <div class="login-header">
      <img class="login-logo" [src]="logo" alt="SAMgruppen">
      <h1 class="login-title sam-page-heading">{{ hasLoggedInBefore ? 'Välkommen tillbaka' : 'Logga in' }}</h1>
      <p class="login-subtitle">{{ hasLoggedInBefore ? 'Kul att ha dig här igen.' : 'Säkert och snabbt.' }}</p>
    </div>

    <div class="login-tabs" role="tablist" aria-label="Inloggningstyp">
      <button type="button"
              class="login-tab"
              [class.active]="selectedLogin === 'bankid'"
              [attr.aria-selected]="selectedLogin === 'bankid'"
              (click)="setLoginTab('bankid')">
        BankID
      </button>
      <button type="button"
              class="login-tab"
              [class.active]="selectedLogin === 'email'"
              [class.disabled]="hideEmailForm"
              [attr.aria-disabled]="hideEmailForm"
              [attr.aria-selected]="selectedLogin === 'email'"
              (click)="setLoginTab('email')">
        E-post
      </button>
    </div>
    <div class="register-row">
      <span>Ny här?</span>
      <a class="register-link" [routerLink]="['/create-account']">Registrera konto</a>
    </div>

    <div *ngIf="isBankIdLogin" class="status-row">
      <span>Loggar in...</span>
      <mat-spinner color="accent" [diameter]="20"></mat-spinner>
    </div>

    <div *ngIf="!isBankIdLogin && selectedLogin === 'bankid'" class="cta-block">
      <button type="button"
              mat-raised-button
              (click)="redirectToURL(bankIdUrl)"
              color="accent"
              name="action"
              class="bankid-button">
        <span class="bankid-icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.70183 12.3759L8.58738 6.86316H7.64145C7.19867 6.86316 6.62843 6.618 6.46071 6.16743C6.40704 6.01503 6.27958 5.49158 7.01083 4.98139C7.27247 4.80249 7.44019 4.60371 7.47373 4.45131C7.50727 4.29229 7.46702 4.15314 7.35297 4.04713C7.19196 3.89473 6.87665 3.80859 6.47413 3.80859C5.79655 3.80859 5.32023 4.1929 5.27327 4.47119C5.23972 4.67659 5.40073 4.84224 5.54162 4.94826C5.96427 5.25968 6.0649 5.71024 5.80326 6.1343C5.53491 6.57161 4.95125 6.85653 4.32734 6.86316H3.36128C3.28078 7.39986 1.96587 15.6293 1.86523 16.2786H7.10475C7.15171 15.9871 7.39323 14.43 7.72195 12.3759H7.70183Z" fill="currentColor"/>
            <path d="M14.7194 2.03906H9.38593L8.6748 6.49833H9.58048C10.0769 6.49833 10.5465 6.27304 10.7478 5.94837C10.8149 5.84236 10.8417 5.74959 10.8417 5.66346C10.8417 5.47793 10.7143 5.33878 10.5868 5.24602C10.2379 4.98761 10.1641 4.71595 10.1641 4.52379V4.41778C10.2446 3.94734 10.8887 3.43714 11.7407 3.43714C12.2506 3.43714 12.6397 3.5564 12.8745 3.77506C13.0824 3.96721 13.1629 4.23888 13.1026 4.52379C13.0288 4.86172 12.6866 5.14001 12.4921 5.27915C11.9755 5.63695 12.0426 5.94837 12.0761 6.04113C12.1835 6.31942 12.5927 6.49833 12.908 6.49833H14.2833C16.1617 6.5182 17.1681 7.37295 16.8527 9.36073C16.5576 11.2094 15.1219 12.0045 13.4112 12.0177L12.7336 16.2848H13.7332C17.953 16.2848 21.4013 13.608 22.0788 9.38061C22.9174 4.13286 19.5497 2.03906 14.7194 2.03906Z" fill="currentColor"/>
          </svg>
        </span>
        Mobilt BankID
      </button>
      <div class="helper-text">Öppnar BankID-appen för inloggning.</div>
    </div>

    <form *ngIf="!otpChallenge && !isBankIdLogin && !hideEmailForm && loginType != 'bankid' && selectedLogin === 'email'" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
      <mat-form-field color="accent" floatLabel="auto">
        <mat-icon after color="accent" matSuffix>account_circle</mat-icon>
        <input matInput [ngModel]="user.username" required autocomplete="email" (ngModelChange)="onUsernameChange($event)" placeholder="E-postadress" id="username" name="username">
      </mat-form-field>

      <div class="login-actions">
        <div class="helper-text">Vi skickar en engångskod till din e-postadress.</div>
        <div class="login-actions-right">
          <button mat-raised-button [hidden]="loading" [disabled]="!f.form.valid" color="accent" type="submit" name="action">Skicka kod</button>
          <mat-spinner color="accent" [diameter]="20" [hidden]="!loading"></mat-spinner>
        </div>
      </div>
    </form>

    <form *ngIf="otpChallenge && selectedLogin === 'email'" class="otp-form" (ngSubmit)="verifyOtp()" #otpForm="ngForm" novalidate>
      <div class="otp-panel">
        <div class="otp-badge">Verifiera e-post</div>
        <p class="otp-helper">Öppna din e-post och skriv eller klistra in engångskoden här.</p>
      </div>

      <div class="otp-shell">
        <label class="otp-label" for="otpCode">Engångskod</label>
        <div class="otp-entry" (click)="focusOtpInput(otpInput)">
          <input #otpInput
                 class="otp-input-native"
                 [ngModel]="otpCode"
                 (ngModelChange)="onOtpCodeChange($event)"
                 (paste)="onOtpPaste($event)"
                 maxlength="6"
                 autocomplete="one-time-code"
                 inputmode="numeric"
                 pattern="[0-9]*"
                 id="otpCode"
                 name="otpCode"
                 required
                 aria-label="Engångskod">
          <div class="otp-slot-group" aria-hidden="true">
            <div class="otp-slot" [class.active]="isOtpSlotActive(0, otpInput)" [class.filled]="getOtpSlotValue(0)">
              <span>{{ getOtpSlotValue(0) }}</span>
              <div *ngIf="isOtpSlotActive(0, otpInput) && !getOtpSlotValue(0)" class="otp-fake-caret"></div>
            </div>
            <div class="otp-slot" [class.active]="isOtpSlotActive(1, otpInput)" [class.filled]="getOtpSlotValue(1)">
              <span>{{ getOtpSlotValue(1) }}</span>
              <div *ngIf="isOtpSlotActive(1, otpInput) && !getOtpSlotValue(1)" class="otp-fake-caret"></div>
            </div>
            <div class="otp-slot" [class.active]="isOtpSlotActive(2, otpInput)" [class.filled]="getOtpSlotValue(2)">
              <span>{{ getOtpSlotValue(2) }}</span>
              <div *ngIf="isOtpSlotActive(2, otpInput) && !getOtpSlotValue(2)" class="otp-fake-caret"></div>
            </div>
            <div class="otp-slot" [class.active]="isOtpSlotActive(3, otpInput)" [class.filled]="getOtpSlotValue(3)">
              <span>{{ getOtpSlotValue(3) }}</span>
              <div *ngIf="isOtpSlotActive(3, otpInput) && !getOtpSlotValue(3)" class="otp-fake-caret"></div>
            </div>
            <div class="otp-slot" [class.active]="isOtpSlotActive(4, otpInput)" [class.filled]="getOtpSlotValue(4)">
              <span>{{ getOtpSlotValue(4) }}</span>
              <div *ngIf="isOtpSlotActive(4, otpInput) && !getOtpSlotValue(4)" class="otp-fake-caret"></div>
            </div>
            <div class="otp-slot" [class.active]="isOtpSlotActive(5, otpInput)" [class.filled]="getOtpSlotValue(5)">
              <span>{{ getOtpSlotValue(5) }}</span>
              <div *ngIf="isOtpSlotActive(5, otpInput) && !getOtpSlotValue(5)" class="otp-fake-caret"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="otp-meta-row">
        <button type="button"
                class="otp-link-button"
                [disabled]="loading || otpResendInSeconds > 0"
                (click)="resendOtp()">
          {{ otpResendInSeconds > 0 ? ('Skicka ny kod (' + otpResendInSeconds + ')') : 'Skicka ny kod' }}
        </button>
      </div>

      <div class="login-actions otp-submit-row">
        <button class="otp-submit-button" mat-raised-button color="accent" type="submit" [disabled]="loading || !canVerifyOtp()">Verifiera</button>
        <mat-spinner color="accent" [diameter]="20" [hidden]="!loading"></mat-spinner>
      </div>
    </form>
  </div>
</div>
